<script>
/**
 * Created by iboying (weboying@gmail.com)
 * Apr 2, 2019 1:56 PM
 * options: https://github.com/simple-uploader/Uploader#full-documentation
 */
import {
  Uploader,
  UploaderBtn,
  UploaderDrop,
  UploaderUnsupport,
  UploaderList,
  UploaderFiles,
  UploaderFile,
} from "vue-simple-uploader";

export default {
  name: "component_file_uploader",
  components: {
    Uploader,
    UploaderBtn,
    UploaderDrop,
    UploaderUnsupport,
    UploaderList,
    UploaderFiles,
    UploaderFile,
  },
  data() {
    return {
      uploading: false,
      listVisible: false,
      fileStatusText: {
        success: "成功",
        error: "失败",
        uploading: "上传中",
        paused: "暂停",
        waiting: "等待",
      },
      files: [],
      errorFileObjects: [],
    };
  },
  props: {
    multiple: {
      type: Boolean,
      default: true,
    },
    chunkSize: {
      type: Number,
      default: 5 * 1024 * 1024,
    },
    simultaneousUploads: {
      type: Number,
      default: 1,
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: "",
    },
    // 配置文件目录
    formPosition: {
      type: Number,
      default: 0,
    },
    itemPosition: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    attrs() {
      return {};
    },
    options() {
      return {
        target: "http://api.shsgzgzjxyjh.cn/user/chunk_files",
        headers: {
          Accept: "application/json",
          ...this.$store.getters.httpAdminHeader,
        },
        categoryMap: {
          // image: ["gif", "jpg", "jpeg", "png", "bmp", "webp", "svg"],
          // video: ["mp4", "m3u8", "rmvb", "avi", "swf", "3gp", "mkv", "flv"],
          // audio: ["mp3", "wav", "wma", "ogg", "aac", "flac"],
          // document: [
          //   "doc",
          //   "txt",
          //   "docx",
          //   "pages",
          //   "epub",
          //   "pdf",
          //   "numbers",
          //   "csv",
          //   "xls",
          //   "xlsx",
          //   "keynote",
          //   "ppt",
          //   "pptx",
          // ],
        },
        testChunks: true,
        simultaneousUploads: this.simultaneousUploads,
        chunkSize: this.chunkSize,
        forceChunkSize: true,
      };
    },
    tips() {
      return {
        // image: '支持png,jpg,jpeg等格式',
        // doc: '支持Doc,Excel，PDF，PPT, .rar等格式.',
        // video: '支持MP4格式',
      }[this.type];
    },
  },
  mounted() {
    this.files = this.fileList || [];
    this.instance = this.$refs.uploader.uploader;
  },
  methods: {
    onTrigger(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!this.uploading) {
        this.$refs.trigger.$el.click();
      }
    },
    onStart() {
      this.uploading = true;
      this.listVisible = true;
    },
    onFileSuccess(rootFile, file, message) {
      const data = JSON.parse(message);
      if (data) {
        this.files.push(data);
        this.$emit("file", data);
      }
    },
    onFileError(rootFile, file) {
      this.errorFileObjects.push(file);
    },
    onComplete() {
      this.uploading = false;
      this.$emit(
        "complete",
        this.files,
        this.formPosition,
        this.itemPosition,
        this.errorFileObjects
      );
    },
    onCancel() {
      this.instance.cancel();
      this.$emit("cancel", this.files, this.errorFileObjects);
      this.reset();
    },
    onConfirm() {
      this.$emit("confirm", this.files, this.errorFileObjects);
      this.listVisible = false;
      this.instance.cancel();
    },
    reset() {
      this.listVisible = false;
      this.uploading = false;
      this.files = [];
      this.errorFileObjects = [];
    },
    // extends
    onClear(index) {
      this.files.splice(index, 1);
      this.instance.cancel();
    },
  },
};
</script>

<template lang="pug">
uploader.file-uploader-container(
  ref="uploader"
  :options="options"
  :fileStatusText="fileStatusText"
  @upload-start="onStart"
  @file-error="onFileError"
  @file-success="onFileSuccess"
  @complete="onComplete")
  uploader-unsupport
  uploader-btn.uploader-btn(ref="trigger" :attrs="attrs" :single="!multiple")
  .uploader-trigger(@click="onTrigger" :class="{ 'trigger-disabled': uploading }")
    slot
  .hint(v-if="tips") {{ tips }}
  .files
    .file(v-for="(file, index) in files" :key="file.id" @click="onClear(index)")
      i.el-icon-document
      .name {{file.name || file.attachment_file_name}}
      i.el-icon-circle-check.icon
      i.el-icon-close.clear
  mu-dialog(
    :open.sync="listVisible"
    title="文件上传"
    @close="onCancel")
    uploader-list
    mu-flat-button(slot="actions" primary @click="onConfirm" label="关闭" :loading="uploading")
</template>

<style lang="stylus">
.file-uploader-container
  display inline-block
  position relative
  .uploader-btn
    padding 0
    border none
    opacity 0
    position absolute
    height 0
    width 0
    visibility hidden
  .trigger-disabled
    opacity 0.6
    cursor not-allowed
  .hint
    font-size 12px
    color #8391a5
    margin-top 7px
  .files
    width 100%
    .file
      display flex
      align-items center
      cursor pointer
      &:hover
        i
          font-size 14px
          color #888
        .clear
          display inline
        .icon
          display none
      img
        width 14px
        height 14px
      .name
        width 100%
        max-width 200px
        color #424344
        margin 0px 5px
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      i
        font-size 14px
        color #13ce66
      .clear
        display none
      .icon
        display inline

.uploader-file
  border-bottom 1px solid #E8E8E8 !important

.uploader-file-icon[icon='folder']::before
  content '📂' !important

.uploader-file-icon[icon='image']::before
  content '🌄' !important

.uploader-file-icon[icon='video']::before
  content '🎬' !important

.uploader-file-icon[icon='audio']::before
  content '🎼' !important

.uploader-file-icon[icon='document']::before
  content '📋' !important
</style>



// WEBPACK FOOTER //
// FileUploader.vue?44671a32